import script from "./SupportDeviceView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupportDeviceView.vue?vue&type=script&lang=ts&setup=true"

import "./SupportDeviceView.vue?vue&type=style&index=0&id=6e438961&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e438961"]])

export default __exports__